import { regexRemoveSpaces, regexRemoveSpecialChars, regexTurkishToEnglish } from 'utils';

export default function makeSlug(text: string): string {
  return regexRemoveSpaces(regexRemoveSpecialChars(regexTurkishToEnglish(text))).toLowerCase();
}
